module.exports = __webpack_public_path__ + "templates/fileManagementFilters.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/core/components/fileManagementFilters/fileManagementFilters.html
// module id = 299
// module chunks = 15